import { DiscoverBuilding } from '../../_types/quickpass-discover'

interface MapBounds {
  minLat: number
  maxLat: number
  minLng: number
  maxLng: number
}

const DEFAULT_CENTER = { latitude: 43.6532, longitude: -79.3832 }
const DEFAULT_ZOOM = 10

const isValidCoordinate = (value: number): boolean => {
  return Number.isFinite(value) && value !== 0
}

const hasValidCoordinates = (building: DiscoverBuilding): boolean => {
  return (
    isValidCoordinate(building.latitude) &&
    isValidCoordinate(building.longitude)
  )
}

const computeBounds = (buildings: DiscoverBuilding[]): MapBounds | null => {
  const valid = buildings.filter(hasValidCoordinates)
  if (valid.length === 0) {
    return null
  }

  let minLat = Number.POSITIVE_INFINITY
  let maxLat = Number.NEGATIVE_INFINITY
  let minLng = Number.POSITIVE_INFINITY
  let maxLng = Number.NEGATIVE_INFINITY

  for (const building of valid) {
    if (building.latitude < minLat) minLat = building.latitude
    if (building.latitude > maxLat) maxLat = building.latitude
    if (building.longitude < minLng) minLng = building.longitude
    if (building.longitude > maxLng) maxLng = building.longitude
  }

  return { minLat, maxLat, minLng, maxLng }
}

const matchScoreTone = (score: number): 'great' | 'good' | 'okay' | 'low' => {
  if (score >= 80) return 'great'
  if (score >= 60) return 'good'
  if (score >= 40) return 'okay'
  return 'low'
}

export {
  DEFAULT_CENTER,
  DEFAULT_ZOOM,
  hasValidCoordinates,
  computeBounds,
  matchScoreTone,
}
export type { MapBounds }
